import { render, staticRenderFns } from "./VideoParser.vue?vue&type=template&id=88fb1ed8"
import script from "./VideoParser.vue?vue&type=script&lang=js"
export * from "./VideoParser.vue?vue&type=script&lang=js"
import style0 from "./VideoParser.vue?vue&type=style&index=0&id=88fb1ed8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports